/**
 * This function helps to make Search Strings persistent
 */

class SessionDataSaver {
  data = new Map<string, string>()
  set(key: string, value: string, enabled?: boolean) {
    if (enabled === false) { return }
    // console.log('SessionDataSaver set', key, value)
    this.data.set(key, value)
  }

  get(key: string, enabled?: boolean): string {
    if (enabled === false) { return '' }
    // console.log('tagFilterArr SessionDataSaver get', key)
    if (this.data.has(key)) {
      // console.log('tagFilterArr SessionDataSaver got', this.data.get(key))
      return this.data.get(key) as string
    }
    // console.log('tagFilterArr SessionDataSaver got nothing')
    return ''
  }

  has(key: string): boolean {
    return this.data.has(key)
  }

  reset() {
    this.data.clear()
  }
}

export const sessionDataSaver = new SessionDataSaver()
